export default "data:image/gif;base64,R0lGODlhBQAIAIABAKSkpOXl5SH5BAEAAAEALAAAAAAFAAgAAAILRB5gp9vW2EqongIAOw=="